module.exports = __webpack_public_path__ + "img/operational-vs-reputational.830eefa2.png";